import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { queries: Array, fields: Array, url: String };

  connect() {
    this.delayTimeout = null;
    this.boundKeyup = this.handleKeyup.bind(this);
    this.boundKeypress = this.handleKeypress.bind(this);
    this.boundClear = this.handleClear.bind(this);

    this.element.addEventListener("keyup", this.boundKeyup);
    this.element.addEventListener("keypress", this.boundKeypress);

    this.element.addEventListener("input", this.boundClear);

    const val = this.element.value;
    this.element.focus();
    this.element.value = '';
    this.element.value = val;
  }

  disconnect() {
    this.element.removeEventListener("keyup", this.boundKeyup);
    this.element.removeEventListener("keypress", this.boundKeypress);
    this.element.removeEventListener("input", this.boundClear);
    clearTimeout(this.delayTimeout);
  }

  handleKeyup(event) {
    clearTimeout(this.delayTimeout);
    this.delayTimeout = setTimeout(() => {
      this.submitSearch();
    }, 500);
  }

  handleKeypress(event) {
    if (event.key === "Enter") {
      event.preventDefault();
    }
  }

  handleClear(event) {
    if (this.element.value === "") {
      this.submitSearch();
    }
  }

  submitSearch() {
    const searchQueries = this.queriesValue;
    const searchableFields = this.fieldsValue;
    const searchUrl = this.urlValue;

    this.submitSearchRequest(searchQueries, searchableFields, searchUrl);
  }

  submitSearchRequest(search_queries, searchable_fields, search_url, extra_params){
    // search_queries contains the friendly field names to be searched
    // searchable_fields contains the actual search params required by ransack
    // search_queries[i] must refer to the same field as searchable_fields[i]
    if(search_queries.length !== searchable_fields.length){
      // search_queries.length MUST BE equal to searchable_fields.length
      return;
    }

    let search_query = search.value;
    let search_params = {};
    let array_search_query = [];

    if(search_query.includes(",")){
      array_search_query = search_query.split(",");
      for(let n = 0; n < array_search_query.length; n++){
        if(array_search_query[n].includes(":")){

          for(let i = 0; i < searchable_fields.length; i++){
            let regex = new RegExp(search_queries[i]+ ":\\s*([a-z0-9]\\s*)*", 'gi');
            let result = array_search_query[n].match(regex);
            if(result != null){
              search_params[searchable_fields[i] + '_cont'] = result[0].split(":")[1].trim();
            }
          }
        }
        else {
          let general_query;
          general_query = searchable_fields[0];
          for(let i = 1; i < searchable_fields.length; i++){
            general_query += '_or_' + searchable_fields[i]
          }
          general_query += '_cont';
          search_params[general_query] = array_search_query[n].trim();
        }
      }
    }
    else {
      if(search_query.includes(":")){

        for(let i = 0; i < searchable_fields.length; i++){
          let regex = new RegExp(search_queries[i]+ ":\\s*([a-z0-9\\s]*)*", 'gi');
          let result = search_query.match(regex);
          if(result != null){
            search_params[searchable_fields[i] + '_cont'] = result[0].split(":")[1].trim();
          }
        }
      }
      else {
        let general_query;
        general_query = searchable_fields[0];
        for(let i = 1; i < searchable_fields.length; i++){
          general_query += '_or_' + searchable_fields[i]
        }
        general_query += '_cont';
        search_params[general_query] = search_query;
      }
    }

    let params = {q: search_params};
    if (typeof extra_params !== "undefined") {
      try {
        const parsedParams = JSON.parse(extra_params);
        params = { ...params, ...parsedParams };
      } catch (error) {
        console.error("Failed to parse extra_params:", error);
      }
    }
    $.ajax({
      method: 'GET',
      url: search_url,
      data: params,
      dataType: 'script'
    });

  }
}
